// extracted by mini-css-extract-plugin
export default {"groupText":"style_groupText__aZo06","introContent":"style_introContent__RwWqR","imageList":"style_imageList__wt3Rv","image":"style_image__Dsx2x"};